import oauth2Links from './oauth2Links';

export default oauth2Links;
